import * as React from 'react';
import type { InjectedRouter } from 'react-router';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import connectToStores from 'js/lib/connectToStores';

import SurveyModal from 'bundles/growth-upsell/user-intent-survey/SurveyModal';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

import 'css!../styl/index';

type Context = {
  router: InjectedRouter;
  getStore: (storeName: string) => void;
};

type Props = {
  children?: React.ReactNode;
  requestCountryCode?: string;
  csrfToken?: string;
} & Context;

const PremiumHubApp: React.FunctionComponent<Props> = ({ children }) => {
  return (
    <div className="rc-PremiumHubApp">
      {children}
      <PageFooter />
      <SurveyModal
        pageType="degreesHub"
        epicParam="tvInterceptSurveyLate2019DegreesHub"
        cookieName="post-tv-survey-dec-2019"
        showForCountryCode="US"
      />
      <SurveyModal
        pageType="degreesHub"
        epicParam="tvInterceptSurveyApr2020GbDegreesHub"
        cookieName="post-tv-survey-gb-apr-2020"
        showForCountryCode="GB"
      />
    </div>
  );
};

export default compose<Props, {}>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'program_hub',
      page: 'premium_hub_app',
    },
  })),
  connectToStores<Props, Props & { csrfToken: string; requestCountryCode: string }>(
    [ApplicationStoreClass],
    (ApplicationStore, props) => ({
      ...props,
      csrfToken: ApplicationStore.getState().csrfToken,
      requestCountryCode: ApplicationStore.getState().requestCountryCode,
    })
  )
)(PremiumHubApp);
